import { Alert, Typography } from "@mui/material";

// #40 - the AOC/LOA hold disclaimer, verbatim from the client. Shown only when
// the submission was held for the principal/agency countersignature.
const AOC_DISCLAIMER =
  "Please note that due to your LOA/AOC payment choice your upline will need to " +
  "complete their portion of your Docusign and submit it back to AGA before we " +
  "are able to move forward with processing your request.";

const Confirmation = ({ data }) => (
  <>
    <Typography variant="h6">
      Thank you for submitting your request! We've sent a copy to your email address.
    </Typography>
    {data?.heldForCountersignature && (
      <Alert severity="info" sx={{ mt: 2 }}>
        {AOC_DISCLAIMER}
      </Alert>
    )}
  </>
);

export default Confirmation;
